/**
 * Main slide interface for the homepage slider
 * Supports both API-driven slides and hardcoded fallback slides
 */
export interface MainSlide {
  id?: number;
  type: 'image' | 'video';
  duration: number; // Duration in milliseconds

  // Image/Video source - for API slides, these come from media_url/poster_url
  src?: string;
  media_url?: string | null;
  poster?: string;
  poster_url?: string | null;
  sources?: Array<{
    src: string;
    type: string;
  }>;

  // Content
  title: string | null;
  subtitle: string | null;
  description: string | null;

  // Button
  buttonImage?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonAlt?: string;
  buttonTarget?: '_blank' | '_self';

  // API button structure
  button?: {
    text: string | null;
    image_url: string | null;
    link: string | null;
    target: '_self' | '_blank';
    alt: string | null;
  } | null;
}

/**
 * Fallback slides used when API is unavailable
 */
export const FALLBACK_SLIDES: MainSlide[] = [
  {
    src: '/assets/images/slider/bg.jpg',
    type: 'image',
    subtitle: 'buyer_homepage.hero_slide_subtitle',
    title: 'buyer_homepage.hero_slide_title',
    description: 'buyer_homepage.hero_slide_description',
    buttonImage: '/assets/images/slider/action-btn.png',
    buttonLink: 'https://bidxsell.com/buyer/auctions/bidxsell-yearlings-sale',
    buttonAlt: 'buyer_homepage.hero_slide_button_alt',
    buttonTarget: '_blank',
    duration: 60000,
  },
  {
    src: '/assets/images/img1.jpg',
    type: 'image',
    subtitle: 'buyer_homepage.premium_experience',
    title: 'buyer_homepage.diverse_bloodstock_portfolio',
    description: 'buyer_homepage.slider_description',
    buttonText: 'buyer_homepage.explore_premium_horses',
    buttonLink: '/buyer/auctions/list/all',
    buttonTarget: '_self',
    duration: 6000,
  },
  {
    type: 'video',
    poster: '/assets/videos/landing-page-hero-videos/Video1.jpg',
    sources: [
      { src: '/assets/videos/landing-page-hero-videos/Video1.mp4', type: 'video/mp4' },
    ],
    subtitle: 'buyer_homepage.premium_experience',
    title: 'buyer_homepage.diverse_bloodstock_portfolio',
    description: 'buyer_homepage.slider_description',
    buttonText: 'buyer_homepage.explore_premium_horses',
    buttonLink: '/buyer/auctions/list/all',
    buttonTarget: '_self',
    duration: 6000,
  },
  {
    type: 'video',
    poster: '/assets/videos/landing-page-hero-videos/Video2.jpg',
    sources: [
      { src: '/assets/videos/landing-page-hero-videos/Video2.mp4', type: 'video/mp4' },
    ],
    subtitle: 'buyer_homepage.premium_experience',
    title: 'buyer_homepage.diverse_bloodstock_portfolio',
    description: 'buyer_homepage.slider_description',
    buttonText: 'buyer_homepage.explore_premium_horses',
    buttonLink: '/buyer/auctions/list/all',
    buttonTarget: '_self',
    duration: 6000,
  },
];
